
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


export default function CallAttemptAccordion(props) {

    return (
        <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
            {props.title}
        </AccordionSummary>
        <AccordionDetails>
            <div>
            <div style={{display: 'block', width: '100%', marginBottom: '10px'}}>
                {props.note ?? ''}
            </div>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px'}}>
                {
                    props.items.map(cd => {
                        return <div><a href={`https://instylesolar3.pipedrive.com/deal/${cd.DealID}`}>https://instylesolar3.pipedrive.com/deal/{cd.DealID}</a></div>
                    })
                }
            </div>
            </div>
        </AccordionDetails>
      </Accordion>
    )
}